import React from "react";

const CookiePopup = ({ onAccept, onReject }) => {
  return (
    <div style={styles.popup}>
      <p>
        Welcome to Utilitarianlabs.com! In order to provide a more relevant experience for you, we use cookies to enable some website functionality. Cookies help us see which articles most interest you; allow you to easily share articles on social media; permit us to deliver content, jobs and ads tailored to your interests and locations; and provide many other site benefits. For more information, please review our <b style={{fontSize:"16px"}}>Cookies Policy</b> and <b style={{fontSize:"16px"}}>Privacy Statement.</b>
        
      </p>
      <div style={styles.btns}>
        <button onClick={onReject} style={styles.reject}>REJECT</button>
        <button onClick={onAccept} style={styles.accept}>ACCEPT</button>
      </div>
    </div>
  );
};

// basic styling
const styles = {
  popup: {
    position: "fixed",
    bottom: "20px",
    left: "50%",
    transform: "translateX(-50%)",
    background: "white",
    width: "90%",
    maxWidth: "1040px",
    padding: "20px",
    borderRadius: "10px",
    boxShadow: "0px 4px 20px rgba(0,0,0,0.2)",
    zIndex: 1000,
  },
  btns: {
    display: "flex",
    justifyContent: "center",
    marginTop: "10px",
    gap: "10px",
  },
  accept: {
    background: "#ff9800",
    color: "#fff",
    padding: "10px 20px",
    border: "none",
    borderRadius: "5px",
    width:"183px"
  },
  reject: {
    background: "#ccc",
    padding: "10px 20px",
    border: "none",
    borderRadius: "5px",
    width:"183px"
  },
  
};

export default CookiePopup;
